import React, { Component } from "react"
import {Progress, Spinner} from "reactstrap"
import themeConfig from '@configs/themeConfig'
import {trans} from '@utils'
class LogoSpinner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            progress: 0
        }
        this.interval = null
    }
    componentDidMount() {
        // Get the current URL path
        const currentPath = window.location.pathname
        if (process.env.REACT_APP_AUTH_MODULE === 'user') {
        localStorage.setItem('currentPathAdmin', currentPath)
        }
        //artist
        const searchParams = new URLSearchParams(window.location.search)
        const code = searchParams.get("code")
        if (!code && process.env.REACT_APP_AUTH_MODULE === 'artist') {
            localStorage.setItem('currentPathArtist', currentPath)
        }
        // Store the current URL path in local storage
        // Retrieve the current URL path from local storage
        //const storedPathAdmin = localStorage.getItem('currentPathAdmin')
        //const storedPathArtist = localStorage.getItem('currentPathArtist')
       // if (storedPathAdmin === null || storedPathAdmin === '' || storedPathAdmin === '/login') {
       
       // }
        // if (storedPathArtist === null || storedPathArtist === '' || storedPathArtist === '/login') {
        //     localStorage.setItem('currentPathArtist', currentPath)
        // }
        this.interval = setInterval(() => {
            const p = this.state.progress + 30
            if (p <= 90) {
                this.setState({progress: p})
            }
        }, 500)
    }
    componentWillUnmount() {
        clearInterval(this.interval)
    }

    render() {
        return (
            <div className='d-flex flex-column justify-content-center align-items-center vh-100 w'>
                {/*<div>*/}
                    <img style={{maxWidth:150, maxHeight:150}} className='mb-4' src={themeConfig.app.appLogoImage}  alt={'asd'}/>
                {/*</div>*/}
                <Spinner className='mr-25'  style={{ height: '3rem', width: '3rem' }} />

                {/* <Progress className='w-25' value={this.state.progress}/> */}
                {/* <p>{process.env.REACT_APP_AUTH_MODULE}</p> */}
                {/* <h3 className='my-3'>{trans('gen.loadingApp', {app: themeConfig.app.appName})}</h3> */}
            </div>
        )
    }
}

export default LogoSpinner
